import React, { useState } from 'react';
import { Modal, Radio, Button, Space, Form } from 'antd';
import CreateIcon from '../../../../assets/Images/icons/create-rr-img.svg';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import RiskRegisterService from '../../../../services/RiskRegister.service';
import useNotify from '../../../../context/Notification/useNotify';
import { ROUTER } from '../../../../constants/router';
export default function ModalCreateRiskRegister({
    open,
    handelClose,
    riskAssessmentId,
}) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const Navigate = useNavigate();
    const [value, setValue] = useState(1);
    const [form] = Form.useForm();
    const notify = useNotify();

    const onChange = (e) => {
        setValue(e.target.value);
    };
    const onSubmit = async () => {
        setLoading(true);
        // สร้างใหม่
        if (value === 1) {
            try {
                const { data } =
                    await RiskRegisterService.createRiskRegisterInitial({
                        riskAssessmentId: riskAssessmentId,
                    });
                if (data.resultCode === 1) {
                    if (value === 1) {
                        return Navigate(
                            `${ROUTER.RISK_MANAGEMENT.RR}/${data?.resultData?.riskRegisterId}`,
                            { state: { mode: 'create' } }
                        );
                    }
                    setLoading(false);
                    handelClose();
                } else {
                    setLoading(false);
                    handelClose();
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: data?.errorData?.msg,
                    });
                }
            } catch (error) {
                setLoading(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: error,
                });
            }
        }
        // คัดลอกจากทะเบียนความเสี่ยงเดิม
        if (value === 2) {
            return Navigate(`${ROUTER.RISK_MANAGEMENT.RR}/cloning`, {
                state: { mode: 'clone' },
            });
        }
    };
    return (
        <Modal
            width={450}
            className="_modal"
            footer={false}
            open={open}
            onCancel={() => {
                setValue(1);
                handelClose();
                form.resetFields();
            }}
        >
            <>
                <div className="flex flex-col space-y-4 justify-center items-center py-4 text-center">
                    <div>
                        <img src={CreateIcon} alt="Create Risk Register" />
                    </div>
                    <div className="text-[22px]">
                        {t('RR.CreateNewRiskRegister')}
                    </div>
                </div>
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    layout="vertical"
                    form={form}
                    onFinish={onSubmit}
                    initialValues={{ createInitail: 1 }}
                >
                    <div className="flex flex-col space-y-4 justify-start items-center py-2 text-left">
                        <Form.Item name="createInitail">
                            <Radio.Group onChange={onChange} value={value}>
                                <Space direction="vertical">
                                    <Radio
                                        className={
                                            value === 1
                                                ? `border-[#7B67FB] border-solid border rounded-lg p-2 shadow-md w-80`
                                                : `border-[#DBDBDB] border-solid border rounded-lg p-2 w-80`
                                        }
                                        key={1}
                                        value={1}
                                        style={{ lineHeight: '32px' }}
                                    >
                                        {t('RR.CreateNew')}
                                    </Radio>
                                    <Radio
                                        className={
                                            value === 2
                                                ? `border-[#7B67FB] border-solid border rounded-lg p-2 shadow-md w-80`
                                                : `border-[#DBDBDB] border-solid border rounded-lg p-2 w-80`
                                        }
                                        key={2}
                                        value={2}
                                        style={{ lineHeight: '32px' }}
                                    >
                                        {t('RR.CloningRiskRegister')}
                                    </Radio>
                                </Space>
                            </Radio.Group>
                        </Form.Item>
                    </div>
                    <div className="flex justify-center items-center py-4 space-x-4">
                        <Button
                            type="primary"
                            onClick={() => {
                                handelClose();
                                setValue(1);
                                form.resetFields();
                            }}
                            size="large"
                            ghost
                        >
                            {t('common.Cancel')}
                        </Button>
                        <Button
                            loading={loading}
                            onClick={() => onSubmit()}
                            size="large"
                            type="primary"
                        >
                            {t('common.Confirm')}
                        </Button>
                    </div>
                </Form>
            </>
        </Modal>
    );
}
